export const ICC_ROUTES = {
    ROOT: '/icc',
    DASHBOARD: '/icc/dashboard',
    PARTICIPANT_DETAILS: '/icc/participant/',
    INTERVENANT_DETAILS: '/icc/intervenant/',
};
